import CurrentSituation from "../pages/dashboard/profile/CurrentSituation";
import InterestAndReason from "../pages/dashboard/profile/InterestAndReason";
import PersonalInformation from "../pages/dashboard/profile/PersonalInformation";
import DocumentsUpload from "../pages/dashboard/profile/DocumentsUpload";
import EducationProfessional from "../pages/dashboard/profile/EducationProfessional";
import SkillsCompetencies from "../pages/dashboard/profile/SkillsCompetencies";
import AISkills from "../pages/dashboard/profile/AISkills";

export const steps = [
  { id: 1, component: CurrentSituation },
  { id: 2, component: InterestAndReason },
  { id: 3, component: PersonalInformation },
  { id: 4, component: EducationProfessional },
  { id: 5, component: SkillsCompetencies },
  // { id: 6, component: AISkills },
  { id: 6, component: DocumentsUpload },
];

export const safeAppend = (formData, key, value) => {
  if (Array.isArray(value)) {
    const cleanedArray = value.filter(v => v !== undefined && v !== null && v !== 'undefined');
    formData.append(key, JSON.stringify(cleanedArray));
  } else if (value === undefined || value === null || value === 'undefined') {
    formData.append(key, "");
  } else {
    formData.append(key, value);
  }
};
